/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-07-22 14:29.
 */
class SpecialReport {

}

module.exports = SpecialReport;
